import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Box, Stack } from '@mui/material';
import { ActionBar, ChapterList } from './Components';
import { EditorProvider } from '../../../../../../contexts/EditorContext';
import { selectEditorStates } from '../../../../../../features/editor/editorSlice';

const ManuscriptArea = ({
  chapters = [],
  onChapterClick = null,
  onSceneAdded,
  onAddScene,
  suppressSceneLoading = false,
}) => {
  const editorStates = useSelector(selectEditorStates);
  const prevSceneIdsRef = useRef(new Set());

  // Log when scenes are added or removed
  useEffect(() => {
    const currentSceneIds = new Set(Object.keys(editorStates || {}));
    const prevSceneIds = prevSceneIdsRef.current;

    // Find added scenes
    const addedScenes = Array.from(currentSceneIds).filter((id) => !prevSceneIds.has(id));
    // Find removed scenes
    const removedScenes = Array.from(prevSceneIds).filter((id) => !currentSceneIds.has(id));

    if (addedScenes.length > 0) {
      console.log('[ManuscriptArea] Scenes ADDED:', addedScenes);
      addedScenes.forEach((sceneId) => {
        console.log('[ManuscriptArea] Added scene data:', {
          sceneId,
          data: editorStates[sceneId],
        });
      });
    }

    if (removedScenes.length > 0) {
      console.log('[ManuscriptArea] Scenes REMOVED:', removedScenes);
    }

    // Update ref for next comparison
    prevSceneIdsRef.current = new Set(currentSceneIds);
  }, [editorStates]);

  return (
    <EditorProvider>
      <Box
        sx={{
          flexGrow: 1,
          width: '100%',
        }}
      >
        <Stack spacing={3}>
          <ActionBar actionBarId="manuscript-action-bar" />
          <ChapterList
            chapters={chapters}
            onChapterClick={onChapterClick}
            onSceneAdded={onSceneAdded}
            onAddScene={onAddScene}
            suppressSceneLoading={suppressSceneLoading}
          />
        </Stack>
      </Box>
    </EditorProvider>
  );
};

/* eslint-disable react/require-default-props */
ManuscriptArea.propTypes = {
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      wordCount: PropTypes.number,
      sceneCount: PropTypes.number,
    })
  ),
  onChapterClick: PropTypes.func,
  onSceneAdded: PropTypes.func,
  onAddScene: PropTypes.func,
  suppressSceneLoading: PropTypes.bool,
};
/* eslint-enable react/require-default-props */

export default ManuscriptArea;
